import React, { useEffect, useState } from 'react';
import { expressURL } from '../utils/networkUtils';
import { formatBuiltAt, parseBuiltAt } from '../utils/buildAge.ts';
import './BuildStamp.scss';

async function loadBuiltAt(): Promise<string | null> {
  const urls = [`${expressURL()}/api/build`, '/build-stamp.json'];
  for (const url of urls) {
    try {
      const response = await fetch(url);
      if (!response.ok) continue;
      const data = await response.json();
      if (parseBuiltAt(data && data.builtAt) != null) return data.builtAt;
    } catch (_) {
      /* try next */
    }
  }
  return null;
}

function BuildStamp() {
  const [builtAt, setBuiltAt] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    loadBuiltAt().then((value) => {
      if (!cancelled) setBuiltAt(value);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!builtAt) return null;

  return (
    <p className="build-stamp">
      Built {formatBuiltAt(builtAt)}
    </p>
  );
}

export default BuildStamp;
